import { render, staticRenderFns } from "./orderSystem.vue?vue&type=template&id=de2628aa&scoped=true"
import script from "./orderSystem.vue?vue&type=script&lang=js"
export * from "./orderSystem.vue?vue&type=script&lang=js"
import style0 from "./orderSystem.vue?vue&type=style&index=0&id=de2628aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2628aa",
  null
  
)

export default component.exports